/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { PropValuesEnum, feeStructureDetails } from "../../constants/commons";
import { feeContainerStyles } from "./styles";
import { ResponsiveWidget, ResponsiveWidgetItem } from "../ResponsiveWidget";
import { Profession } from "../../commons/interfaces";

interface FeesGuidelinesProps {
  profession?: Profession;
}

export const FeesGuidelines: React.FunctionComponent<FeesGuidelinesProps> = (
  props
) => {
  const { profession } = props;

  const getFeeContent = () => {
    return (
      <ResponsiveWidgetItem cardView className="pb-4 bx-shadow-none">
        <div>
          {feeStructureDetails.map((item, key) => {
            return (
              <React.Fragment key={key}>
                {!profession && (
                  <React.Fragment>
                    <h5 className="payment-service-type">{item.type}</h5>
                    <hr />
                  </React.Fragment>
                )}
                {item.content.map((e, i) => {
                  if (
                    !profession ||
                    (profession &&
                      item.type === "Medical Services" &&
                      (profession === Profession.THERAPST ||
                        profession === Profession.PHYSIOTHERAPIST ||
                        profession === Profession.DOCTOR ||
                        profession === Profession.PSYCHIATRIST ||
                        profession === Profession.NUTRITIONIST)) ||
                    (item.type === "Non-Medical Services" &&
                      (profession === Profession.CHEF ||
                        profession === Profession.FITNESS_TRAINER ||
                        profession === Profession.YOGA_TRAINER))
                  )
                    return (
                      <React.Fragment key={i}>
                        <h6>{e.heading}</h6>
                        <div className="text-container mb-3">{e.body}</div>
                      </React.Fragment>
                    );
                  else {
                    return <React.Fragment key={i}></React.Fragment>;
                  }
                })}
              </React.Fragment>
            );
          })}
        </div>
      </ResponsiveWidgetItem>
    );
  };

  return (
    <React.Fragment>
      <div className="header-container mb-4">
        <h5>Fee structure</h5>
        {/* <LinkButton>View T&C</LinkButton> */}
      </div>
      <ResponsiveWidget
        align={PropValuesEnum.VERTICAL}
        css={feeContainerStyles}
      >
        {getFeeContent()}
      </ResponsiveWidget>
    </React.Fragment>
  );
};
